import store from '@/store/index';
import Firebase from './Firebase.js'
import { getFirestore } from "firebase/firestore";
import { Capacitor } from '@capacitor/core';
import {version} from '../../package.json';
import api from '@/services/Api'

// ----------------------------- o
// make sure you run: npm install @firebase
// make sure you have firebase SDK 7.20.0 not 8+
const db = Firebase.firestore()

// ----------------------------- o

export default {
    async firestoreInit() {
        console.log('_________________firestoreInit')
        const token = store.state.auth.deviceToken
        console.log('_________________firestoreInit', token)
        console.log('_________________firestoreInit', db)

        if (!token) return false;
        if (!db) return false;
        //
        const devices = db.collection('devices');
        const data = {
            token: token,
            platform: Capacitor.platform,
            updated: Date.now(),
            version: version,
            apiUrl: api.defaults.baseURL
        }

        // add optional fields
        if(store.getters.getProfile.id) data['userId'] = store.getters.getProfile.id;
        if(store.getters.getProfile.clientNumber) data['clientNumber'] = store.getters.getProfile.clientNumber;
        if(store.getters.getProfile.username) data['userName'] = store.getters.getProfile.username;

        // set data
        return devices.doc(token).set(data)
            .then(() => {
                console.log("Firestore successfully written!");
            })
            .catch((error) => {
                console.error("Error writing to Firestore: ", error);
            })
    }
}
